import { Link } from 'react-router-dom';
import { Logo } from '@/components/Logo';
import { Button } from '@/components/ui/Button';

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-brand-off-white px-4">
      <Logo height={48} />
      <h1 className="mt-8 text-3xl font-semibold text-brand-charcoal">404</h1>
      <p className="mt-2 text-sm text-brand-gray-mid">
        The page you're looking for doesn't exist.
      </p>
      <Link to="/" className="mt-6">
        <Button>Back to dashboard</Button>
      </Link>
    </div>
  );
}
